import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import Lottie from 'lottie-web'
import { useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'
import * as styles from './style'

export interface Props {
  sessionName?: string
}

const successImageLottieJsonUrl = 'https://ddq2bomue87t4.cloudfront.net/dialog-icons/success.json'

const CancelBookingSuccess = ({ sessionName }: Props): JSX.Element => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (ref) {
      Lottie.loadAnimation({
        name: 'dialog-animation',
        container: ref,
        renderer: 'canvas',
        loop: false,
        autoplay: true,
        path: successImageLottieJsonUrl,
      })
    }

    return () => {
      if (ref) {
        Lottie.destroy('dialog-animation')
      }
    }
  }, [ref])

  const { t } = useTranslation('classes')
  return (
    <Layout spacing="lg">
      <Stack y alignSelf="flex-start">
        <Stack y justifyContent="center" alignItems="center" className="pt-lg pb-lg">
          <div ref={(newRef) => setRef(newRef)} className={styles.heroAnimation} />
          <Text className="ta-c pt-lg">{sessionName}</Text>
          <Text size="xs" weight="sm" className="ta-c pt-lg">
            {t('cancelClass.success')}
          </Text>
        </Stack>
      </Stack>
    </Layout>
  )
}
export default CancelBookingSuccess
